import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import { TableRow, TableSortLabel, withStyles } from "@material-ui/core";
import { useTranslations } from "adapters/i18n";

export const headCells = [
  {
    id: "name",
    label: "goalPlan:goal-plan-name",
  },
  {
    id: "version",
    label: "common:version",
  },
  {
    id: "initialDate",
    label: "common:date",
  },
  {
    id: "active",
    label: "common:situation",
  },
];

const GoalPlanListTableHeader = (props) => {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

   const { t } = useTranslations();

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
            className={classes.tableCell}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {t(headCell.label)}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell className={classes.tableCell}>{t("common:action")}</TableCell>
      </TableRow>
    </TableHead>
  );
};

const styles = (theme) => ({
  tableCell: {
    fontFamily: "Roboto",
    textTransform: "uppercase",
    fontSize: 14,
    lineHeight: 1.29,
    color: theme.palette.primary.main,
    backgroundColor: "#e1e1e1",
    maxWidth: "130px",
    padding: "4px 56px 4px 24px",
  },
});

export default withStyles(styles)(GoalPlanListTableHeader);
